
import WorkInfo from '../components/Work/WorkInfo'
export default {
  components: {
    WorkInfo
  },
  data () {
    return {
      img: 'work-01',
      title: 'Working with MDF'
    }
  }
}
